import dayjs from "@shared/dayjs";

const today = dayjs();

const getDateDropdownOptions = (year, type) => {
  const dropdownItems = [];
  const ytdEndDate = dayjs().set("year", year);
  const ytdStartDate = ytdEndDate.subtract(11, "month");
  const calendarEndDate = dayjs().set("year", year).endOf("year");
  const calendarStartDate = calendarEndDate.startOf("year");

  const isThisYear = String(year) === String(today.year());

  dropdownItems.push({
    label: isThisYear
      ? "This Year"
      : `${calendarStartDate.format("MMM YYYY")} - ${calendarEndDate.format("MMM YYYY")}`,
    value: "calendar",
  });

  dropdownItems.push({
    label: isThisYear
      ? "Last 12 Months"
      : `${ytdStartDate.format("MMM YYYY")} - ${ytdEndDate.format("MMM YYYY")}`,
    value: "mtd",
  });
  if (type === "extended") {
    dropdownItems.push({
      label: isThisYear ? "This Month" : `${ytdEndDate.format("MMM YYYY")}`,
      value: "this_month",
    });
    dropdownItems.push({
      label: isThisYear ? "Last Month" : `${ytdEndDate.subtract(1, "month").format("MMM YYYY")}`,
      value: "last_month",
    });
    dropdownItems.push({
      label: isThisYear
        ? "This Week"
        : `${ytdEndDate.startOf("week").format("MMM D")} - ${ytdEndDate
            .endOf("week")
            .format("MMM D YYYY")}`,
      value: "this_week",
    });
    dropdownItems.push({
      label: isThisYear
        ? "Last Week"
        : `${ytdEndDate.subtract(1, "week").startOf("week").format("MMM D")} - ${ytdEndDate
            .subtract(1, "week")
            .endOf("week")
            .format("MMM D YYYY")}`,
      value: "last_week",
    });
  }

  return dropdownItems;
};

export default getDateDropdownOptions;
